import moment from "moment";

class EpochMonthService {
    // Returns months since 1970
    static getTodayEpochMonth() {
        const nineteenSeventy = moment("1970-01-01");
        const today = moment();
        return today.diff(nineteenSeventy, 'months');
    }

    // Convert epoch month to MMM yy
    static epochMonthToMMMYY(epochMonth: number) {
        const nineteenSeventy = moment("1970-01-01");
        const date = nineteenSeventy.add(epochMonth, 'months');
        return date.format("MMM, YY");
    }

    // Convert epoch month to MMM
    static epochMonthToMMM(epochMonth: number) {
        const nineteenSeventy = moment("1970-01-01");
        const date = nineteenSeventy.add(epochMonth, 'months');
        return date.format("MMM");
    }

    // Convert epoch month to MMMM
    static epochMonthToMMMM(epochMonth: number) {
        const nineteenSeventy = moment("1970-01-01");
        const date = nineteenSeventy.add(epochMonth, 'months');
        return date.format("MMMM");
    }
}

export default EpochMonthService;